export default {
  setStreetNameOptions: (state, streetNameOptions) => {
    state.propertyAddress.streetNameOptions =
      streetNameOptions &&
      streetNameOptions.map(item => {
        return { id: item.id, label: item.name };
      });
  },
  setIsStreetNameValid: (state, isValid) => {
    state.propertyAddress.isStreetNameValid = isValid;
  },
  setProperties: (state, properties) => {
    state.propertyAddress.properties = properties;
  },
  setPostOrderDetails: (state, orderDetails) => {
    state.postOrderDetails = orderDetails;
  },
  setProductDetails: (state, productDetails) => {
    state.productDetails = productDetails;
  },
  setTaxAdjustmentOrderId: (state, id) => {
    state.taxAdjustmentOrderId = id;
  },
  setOrderDetails: (state, orderDetails) => {
    state.orderDetails = orderDetails;
  },
  setTaxAdjustmentDetails: (state, taxAdjustmentDetails) => {
    state.taxAdjustmentDetails = taxAdjustmentDetails;
  },
  setReasonConfigurations: (state, reasonConfigurations) => {
    const currentYearReasons = (reasonConfigurations || []).filter(
      reason => reason.ReasonId !== 10
    );
    const precedingYearReasons = (reasonConfigurations || []).filter(
      reason => reason.ReasonId === 10
    );
    state.reasonConfigurations = { currentYearReasons, precedingYearReasons };
  },
  setValue: (state, response) => {
    if (response) {
      if (typeof response.value === "object") {
        state[response.key] = { ...state[response.key], ...response.value };
      } else {
        state[response.key] = response.value;
      }
    }
  },
  setErrors: (state, error) => {
    state.errors = { ...state.errors, ...error };
  }
};
